module.exports = __webpack_public_path__ + "img/gsjj.67f7ba77.jpg";